import React, { useState } from 'react'
import { Settings } from '@mui/icons-material'
import {
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material'
import useGetProfile from '@/modules/SettingComponent/services/hooks/useGetProfile'

interface HeaderPropsType {
  handleNotification: () => void
  handleClickSetting: () => void
  newNotificationCounts: number
}

const Header: React.FC<HeaderPropsType> = ({
  handleNotification,
  handleClickSetting,
  newNotificationCounts,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const { data: getProfile } = useGetProfile()

  const handleAppAnalytics = () => {
    window.open(
      'https://console.firebase.google.com/project/ankle-patrol/analytics/app/ios:com.AnklePatrol.dev/overview/reports~2Fdashboard%3Fparams%3D_u.comparisonOption%253Ddisabled%2526_u.date00%253D20241011%2526_u.date01%253D20241011&r%3Dfirebase-overview&fpn%3D232466101118',
    )
  }
  const handleCrashAnalytics = () => {
    window.open(
      'https://console.firebase.google.com/project/ankle-patrol/crashlytics/app/ios:com.AnklePatrol.dev/issues',
    )
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className="dashboard-header">
      <div>
        <img alt="logo" src={'/icon/AnklePatrol_Logo_white (1) 1.svg'} />
      </div>
      <div className="header-menu gap-4">
        <div
          className="bell cursor-pointer relative"
          onClick={handleNotification}
        >
          <img alt="bell" src={'/icon/Bell orange icon.svg'} />
          {newNotificationCounts > 0 && (
            <div className="rounded-3xl leading-[0.5rem] min-h-6 min-w-6 p-2  text-sm top-0 right-[-7px] bg-[#5b5757]  text-white absolute">
              {newNotificationCounts}
            </div>
          )}
        </div>
        {(getProfile?.data?.userProfile?.firstName ||
          getProfile?.data?.userProfile?.lastName) && (
          <div className="items-center justify-items-center gap-1 b bg-grad before:!rounded-[40px]">
            <Tooltip title="Account settings">
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                className="bg-gradient-to-b from-[rgba(54,95,145,0.2)] to-[rgba(54,95,145,0.1)] !rounded-[40px] backdrop-blur-lg !ml-0 !py-[15px] !px-[20px] !text-[16px] !text-white"
              >
                {getProfile?.data?.userProfile?.firstName}&nbsp;
                {getProfile?.data?.userProfile?.lastName}
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    bgcolor: '#223249',
                    borderRadius: '10px',
                    boxSizing: 'border-box',
                    color: 'white',
                    '& .MuiAvatar-root': {
                      background: `#454444`,
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '& .MuiMenuItem-root': {
                      '&:hover': {
                        bgcolor: '#365e9133',
                      },
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem onClick={handleAppAnalytics}>App Analytics</MenuItem>
              <MenuItem onClick={handleCrashAnalytics}>
                Crash Analytics
              </MenuItem>
              <Divider className="text-white" />
              <MenuItem onClick={handleClickSetting}>
                <ListItemIcon>
                  <Settings fontSize="small" className="text-white" />
                </ListItemIcon>
                Settings
              </MenuItem>
            </Menu>
          </div>
        )}
      </div>
    </div>
  )
}

export default Header
